import { handleActions } from 'redux-actions'
import {
    listarCoberturasAPIsLoading,
    listarCoberturasAPhasError,
    setListarCoberturasAP,
    setCrearCarritoTravelGroup,
    crearCarritoTravelGroupError,
    crearCarritoTravelGrouploading,
    agregarProductoCarritoloading,
    agregarProductoCarritoError,
    setAgregarProductoCarrito,
    calculoCotizacionAPIsLoading,
    calculoCotizacionAPhasError,
    setCalculoCotizacionAP,
    recuperarCarritoAPIsLoading,
    recuperarCarritoAPhasError,
    setRecuperarCarritoAP,
    generarCotizacionCarritoAPIsLoading,
    generarCotizacionAPhasError,
    setGenerarCotizacionCarritoAP,    
    enviarCotizacionCarritoAPIsLoading,
    enviarCotizacionAPhasError,
    setEnviarCotizacionCarritoAP,
    obtenerPlanesAccPIsLoading,
    obtenerPlanesAccPhasError,
    resetStateAP,
    setObtenerPlanesAccP,
    setObtenerPlanesAccPAigmed,
    obtenerPlanesAccPAigmedhasError,
    emisionRetroactivaIsLoading,
    emisionRetroactivaHasError,
    setEmisionRetroactiva,
    setCrearCarritoAccP,
    crearCarritoAccPError,
    crearCarritoAccPloading,
    setObtenerProvinciasAP,
    obtenerProviciasAPError,
    obtenerProvinciasLoading,
    setObtenerCiudadesAP,
    obtenerCiudadesAPError,
    obtenerCiudadesLoading,
    listarCoberturasAccPIsLoading,
    listarCoberturasAccPhasError,
    setListarCoberturasAccP,
    recuperarCarritoAccPIsLoading,
    recuperarCarritoAccPhasError,
    setRecuperarCarritoAccP,
    procesoCarritoAccPIsLoading,
    procesoCarritoAccPhasError,
    setProcesoCarritoAccP,
    enviarCotizacionCarritoAccPIsLoading,
    enviarCotizacionAccPhasError,
    setEnviarCotizacionCarritoAccP
} from '../actions/aRamoAccidentesPersonales';

  //Listar Limites - Cotizacion Financiero mediate redux-actions
  export const datosCoberturasAP = handleActions(
    {
      [listarCoberturasAPIsLoading]: (state) => ({...state,listarCoberturasAPIsLoading: true,listarCoberturasAPhasError:false,}),
      [listarCoberturasAPhasError]: (state) => ({...state,listarCoberturasAPhasError:true,listarCoberturasAPIsLoading: false}),
      [setListarCoberturasAP]: (state,action) => ({...state,listarCoberuras: action.payload, listarCoberturasAPhasError:false,listarCoberturasAPIsLoading: false })
    },
    {
        listarCoberturasAPIsLoading: false,
        listarCoberturasAPhasError: false,
        listarCoberuras: [],
    }
  );


   //crear carrito ap travel group
   export const datosCarritoAPTravelGroup = handleActions(
    {
      [crearCarritoTravelGrouploading]: (state) => ({...state,crearCarritoTravelGrouploading: true,crearCarritoTravelGroupError:false,}),
      [crearCarritoTravelGroupError]: (state) => ({...state,crearCarritoTravelGroupError:true,crearCarritoTravelGrouploading: false}),
      [setCrearCarritoTravelGroup]: (state,action) => ({...state,carritoAPTravelGroup: action.payload, crearCarritoTravelGroupError:false,crearCarritoTravelGrouploading: false })
    },
    {
      crearCarritoTravelGrouploading: false,
      crearCarritoTravelGroupError: false,
      carritoAPTravelGroup: [],
    }
  );



  //crear carrito ap travel group
  export const datosProductoCarritoAPTravelGroup = handleActions(
    {
      [agregarProductoCarritoloading]: (state) => ({...state,agregarProductoCarritoloading: true,agregarProductoCarritoError:false,}),
      [agregarProductoCarritoError]: (state) => ({...state,agregarProductoCarritoError:true,agregarProductoCarritoloading: false}),
      [setAgregarProductoCarrito]: (state,action) => ({...state,productoAPTravelGroup: action.payload, agregarProductoCarritoError:false,agregarProductoCarritoloading: false })
    },
    {
      agregarProductoCarritoloading: false,
      agregarProductoCarritoError: false,
      productoAPTravelGroup: [],
    }
  );


//Realizar Calculos - Cotizacion Accidentes Personales mediate redux-actions
export const datosCalculosCotizacionAP = handleActions(
  {
    [calculoCotizacionAPIsLoading]: (state) => ({ ...state, calculoCotizacionAPIsLoading: true, calculoCotizacionAPhasError: false, }),
    [calculoCotizacionAPhasError]: (state) => ({ ...state, calculoCotizacionAPhasError: true, calculoCotizacionAPIsLoading: false }),
    [setCalculoCotizacionAP]: (state, action) => ({ ...state, calculoCotizacionAP: action.payload, calculoCotizacionAPhasError: false, calculoCotizacionAPIsLoading: false }),
    
    //Emision Retroactiva
    [emisionRetroactivaIsLoading]: (state) => ({ ...state, emisionRetroactivaIsLoading: true, emisionRetroactivaHasError: false }),
    [emisionRetroactivaHasError]: (state) => ({ ...state, emisionRetroactivaHasError: true, emisionRetroactivaIsLoading: false }),
    [setEmisionRetroactiva]: (state, action) => ({ ...state, emisionRetroactiva: action.payload, emisionRetroactivaHasError: false, emisionRetroactivaIsLoading: false }),
    [resetStateAP]: (state) => ({
      ...state,
      calculoCotizacionAPIsLoading: false,
      calculoCotizacionAPhasError: false,
      calculoCotizacionAP: [],
      emisionRetroactivaIsLoading: false,
      emisionRetroactivaHasError: false,
      emisionRetroactiva: []
    })
  },
  {
    calculoCotizacionAPIsLoading: false,
    calculoCotizacionAPhasError: false,
    calculoCotizacionAP: [],
    emisionRetroactivaIsLoading: false,
    emisionRetroactivaHasError: false,
    emisionRetroactiva: []
  }
);



//Recuperar Carrito - Cotizacion Accidentes Personales mediate redux-actions
export const datosRecuperarCarritoAP = handleActions(
  {
    [recuperarCarritoAPIsLoading]: (state) => ({ ...state, recuperarCarritoAPIsLoading: true, recuperarCarritoAPhasError: false, }),
    [recuperarCarritoAPhasError]: (state) => ({ ...state, recuperarCarritoAPhasError: true, recuperarCarritoAPIsLoading: false }),
    [setRecuperarCarritoAP]: (state, action) => ({ ...state, recuperarCarritoAP: action.payload, recuperarCarritoAPhasError: false, recuperarCarritoAPIsLoading: false }),
    [resetStateAP]: (state) => ({
      ...state,
      recuperarCarritoAPIsLoading: false,
      recuperarCarritoAPhasError: false,
      recuperarCarritoAP: [],
    })
  },
  {
    recuperarCarritoAPIsLoading: false,
    recuperarCarritoAPhasError: false,
    recuperarCarritoAP: [],
  }
);


//Recuperar Carrito - Cotizacion Accidentes Personales mediate redux-actions
export const generarCotizacionPdfAP = handleActions(
  {
    [generarCotizacionCarritoAPIsLoading]: (state) => ({ ...state, generarCotizacionCarritoAPIsLoading: true, generarCotizacionAPhasError: false, }),
    [generarCotizacionAPhasError]: (state) => ({ ...state, generarCotizacionAPhasError: true, generarCotizacionCarritoAPIsLoading: false }),
    [setGenerarCotizacionCarritoAP]: (state, action) => ({ ...state, generarCotizacionAP: action.payload, generarCotizacionAPhasError: false, generarCotizacionCarritoAPIsLoading: false }),
    [resetStateAP]: (state) => ({
      ...state,
      generarCotizacionCarritoAPIsLoading: false,
      generarCotizacionAPhasError: false,
      generarCotizacionAP: [],
    })
  },
  {
    generarCotizacionCarritoAPIsLoading: false,
    generarCotizacionAPhasError: false,
    generarCotizacionAP: [],
  }
);



//enviar email con cotizacion

export const datosEnviarCotizacionPdfAP = handleActions(
  {
    [enviarCotizacionCarritoAPIsLoading]: (state) => ({ ...state, enviarCotizacionCarritoAPIsLoading: true, enviarCotizacionAPhasError: false, }),
    [enviarCotizacionAPhasError]: (state) => ({ ...state, enviarCotizacionAPhasError: true, enviarCotizacionCarritoAPIsLoading: false }),
    [setEnviarCotizacionCarritoAP]: (state, action) => ({ ...state, enviarCotizacionAP: action.payload, enviarCotizacionAPhasError: false, enviarCotizacionCarritoAPIsLoading: false }),
    [resetStateAP]: (state) => ({
      ...state,
      enviarCotizacionCarritoAPIsLoading: false,
      enviarCotizacionAPhasError: false,
      enviarCotizacionAP: [],
    })
  },
  {
    enviarCotizacionCarritoAPIsLoading: false,
    enviarCotizacionAPhasError: false,
    enviarCotizacionAP: [],
  }
);




//obtener planes

export const listaPlanesAccP = handleActions(
  {
    [obtenerPlanesAccPIsLoading]: (state) => ({ ...state, obtenerPlanesAccPIsLoading: true, obtenerPlanesAccPhasError: false, }),
    [obtenerPlanesAccPhasError]: (state) => ({ ...state, obtenerPlanesAccPhasError: true, obtenerPlanesAccPIsLoading: false }),
    [setObtenerPlanesAccP]: (state, action) => ({ ...state, planesCotizacionAccP: action.payload, obtenerPlanesAccPhasError: false, obtenerPlanesAccPIsLoading: false }),
    [setObtenerPlanesAccPAigmed]: (state, action) => ({ ...state, planesAccPAigmed: action.payload, obtenerPlanesAccPAigmedhasError: false, obtenerPlanesAccPIsLoading: false })
  },
  {
    obtenerPlanesAccPIsLoading: false,
    obtenerPlanesAccPhasError: false,
    planesCotizacionAccP: [],
  }
);


//obtener planes

export const datosCarritoAccP = handleActions(
  {
    [crearCarritoAccPloading]: (state) => ({ ...state, crearCarritoAccPloading: true, crearCarritoAccPError: false, }),
    [crearCarritoAccPError]: (state) => ({ ...state, crearCarritoAccPError: true, crearCarritoAccPloading: false }),
    [setCrearCarritoAccP]: (state, action) => ({ ...state, productoAccP: action.payload, crearCarritoAccPError: false, crearCarritoAccPloading: false })
  },
  {
    crearCarritoAccPloading: false,
    crearCarritoAccPError: false,
    productoAccP: [],
  }
);




//obtener provincias

export const listaProvinciasAP = handleActions(
  {
    [obtenerProvinciasLoading]: (state) => ({ ...state, obtenerProvinciasLoading: true, obtenerProviciasAPError: false, }),
    [obtenerProviciasAPError]: (state) => ({ ...state, obtenerProviciasAPError: true, obtenerProvinciasLoading: false }),
    [setObtenerProvinciasAP]: (state, action) => ({ ...state, provinciasAP: action.payload, obtenerProviciasAPError: false, obtenerProvinciasLoading: false })
  },
  {
    obtenerProvinciasLoading: false,
    obtenerProviciasAPError: false,
    provinciasAP: [],
  }
);




//obtener ciudades

export const listaCiudadesAP = handleActions(
  {
    [obtenerCiudadesLoading]: (state) => ({ ...state, obtenerCiudadesLoading: true, obtenerCiudadesAPError: false, }),
    [obtenerCiudadesAPError]: (state) => ({ ...state, obtenerCiudadesAPError: true, obtenerCiudadesLoading: false }),
    [setObtenerCiudadesAP]: (state, action) => ({ ...state, ciudadesAP: action.payload, obtenerCiudadesAPError: false, obtenerCiudadesLoading: false })
  },
  {
    obtenerCiudadesLoading: false,
    obtenerCiudadesAPError: false,
    ciudadesAP: [],
  }
);


//listar cobetrturas accp

export const listaCoberturasAccP = handleActions(
  {
    [listarCoberturasAccPIsLoading]: (state) => ({ ...state, listarCoberturasAccPIsLoading: true, listarCoberturasAccPhasError: false}),
    [listarCoberturasAccPhasError]: (state) => ({ ...state, listarCoberturasAccPhasError: true, listarCoberturasAccPIsLoading: false }),
    [setListarCoberturasAccP]: (state, action) => ({ ...state, coberturasAccP: action.payload, listarCoberturasAccPhasError: false, listarCoberturasAccPIsLoading: false })
  },
  {
    listarCoberturasAccPIsLoading: false,
    listarCoberturasAccPhasError: false,
    coberturasAccP: [],
  }
);




//Recuperar Carrito - Cotizacion Accidentes Personales mediate redux-actions
export const datosRecuperarCarritoAccP = handleActions(
  {
    [recuperarCarritoAccPIsLoading]: (state) => ({ ...state, recuperarCarritoAccPIsLoading: true, recuperarCarritoAccPhasError: false, }),
    [recuperarCarritoAccPhasError]: (state) => ({ ...state, recuperarCarritoAccPhasError: true, recuperarCarritoAccPIsLoading: false }),
    [setRecuperarCarritoAccP]: (state, action) => ({ ...state, recuperarCarritoAccP: action.payload, recuperarCarritoAccPhasError: false, recuperarCarritoAccPIsLoading: false })
  },
  {
    recuperarCarritoAccPIsLoading: false,
    recuperarCarritoAccPhasError: false,
    recuperarCarritoAccP: [],
  }
);




//Recuperar Carrito - Cotizacion Accidentes Personales mediate redux-actions
export const datosProcesoCarritoAccP = handleActions(
  {
    [procesoCarritoAccPIsLoading]: (state) => ({ ...state, procesoCarritoAccPIsLoading: true, procesoCarritoAccPhasError: false, }),
    [procesoCarritoAccPhasError]: (state) => ({ ...state, procesoCarritoAccPhasError: true, procesoCarritoAccPIsLoading: false }),
    [setProcesoCarritoAccP]: (state, action) => ({ ...state, procesoCarritoAccP: action.payload, procesoCarritoAccPhasError: false, procesoCarritoAccPIsLoading: false })
  },
  {
    procesoCarritoAccPIsLoading: false,
    procesoCarritoAccPhasError: false,
    procesoCarritoAccP: [],
  }
);






//enviar email con cotizacion

export const datosEnviarCotizacionPdfAccP = handleActions(
  {
    [enviarCotizacionCarritoAccPIsLoading]: (state) => ({ ...state, enviarCotizacionCarritoAccPIsLoading: true, enviarCotizacionAccPhasError: false, }),
    [enviarCotizacionAccPhasError]: (state) => ({ ...state, enviarCotizacionAccPhasError: true, enviarCotizacionCarritoAccPIsLoading: false }),
    [setEnviarCotizacionCarritoAccP]: (state, action) => ({ ...state, enviarCotizacionAccP: action.payload, enviarCotizacionAccPhasError: false, enviarCotizacionCarritoAccPIsLoading: false })
  },
  {
    enviarCotizacionCarritoAccPIsLoading: false,
    enviarCotizacionAccPhasError: false,
    enviarCotizacionAccP: [],
  }
);